<template>
  <div>
    <!-- breadcrumb start -->
    <div class="breadcrumb-section">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="page-title">
              <h2>我的页面</h2>
            </div>
          </div>
          <div class="col-sm-6">
            <nav aria-label="breadcrumb" class="theme-breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="./index.html">主页</a></li>
                <li class="breadcrumb-item active" aria-current="page">我的页面</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <!-- breadcrumb End -->

    <!--  dashboard section start -->
    <section class="dashboard-section section-b-space user-dashboard-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-3">
            <div class="dashboard-sidebar">
              <div class="profile-top">
                <div class="profile-image">
                  <img :src="user.avatar" alt="" class="img-fluid">
                </div>
                <div class="profile-detail">
                  <h5>{{ user.username }}</h5>
                  <h6>{{ user.email }}</h6>
                </div>
              </div>
              <div class="faq-tab">
                <ul class="nav nav-tabs" id="top-tab" role="tablist">
                  <li class="nav-item">
                    <a data-bs-toggle="tab" data-bs-target="#info" @click="showMenu('info')"
                       class="nav-link" :class="{'active': currentTab === 'info'}">我的账号</a>
                  </li>
                  <li class="nav-item">
                    <a data-bs-toggle="tab" data-bs-target="#orders" @click="showMenu('trade')"
                       class="nav-link" :class="{'active': currentTab === 'trade'}">我的订单</a>
                  </li>
                  <li class="nav-item">
                    <a data-bs-toggle="tab" data-bs-target="#devices" @click="showMenu('device')"
                       class="nav-link" :class="{'active': currentTab === 'device'}">我的设备</a>
                  </li>
                  <li class="nav-item">
                    <a data-bs-toggle="tab" data-bs-target="#ip" @click="showMenu('ip')"
                       class="nav-link" :class="{'active': currentTab === 'ip'}">IP查询</a>
                  </li>
                  <li class="nav-item" v-if="coupons.length > 0">
                    <a data-bs-toggle="tab" data-bs-target="#commission" @click="showMenu('commission')"
                       class="nav-link" :class="{'active': currentTab === 'commission'}">结佣管理</a>
                  </li>
                  <li class="nav-item">
                    <a @click="logout" class="nav-link">退出登录</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-lg-9">
            <div class="faq-content tab-content" id="top-tabContent">
              <div class="tab-pane fade" :class="{'active': currentTab === 'info', 'show': currentTab === 'info'}" id="info">
                <div class="counter-section">
                  <div class="welcome-msg">
                    <h4>Hello, {{ user.nickname }} !</h4>
                    <p></p>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="counter-box" @click="goTrade" style="cursor: pointer;">
                        <img src="../../assets/images/icon/dashboard/sale.png" class="img-fluid">
                        <div>
                          <h3>{{ total[0] }}</h3>
                          <h5>订单合计</h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="counter-box" @click="goTrade" style="cursor: pointer;">
                        <img src="../../assets/images/icon/dashboard/homework.png" class="img-fluid">
                        <div>
                          <h3>{{ total[1] }}</h3>
                          <h5>进行中订单</h5>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="counter-box" @click="goTrade" style="cursor: pointer;">
                        <img src="../../assets/images/icon/dashboard/order.png" class="img-fluid">
                        <div>
                          <h3>{{ total[2] }}</h3>
                          <h5>完成订单</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box-account box-info">
                    <div class="box-head">
                      <h4>账号信息</h4>
                    </div>
                    <a-form :label-col="{ span: 3 }" :wrapper-col="{ span: 9 }">
                      <a-form-item label="用户名 *">
                        <a-input v-model="username" style="width: 200px;" :disabled="!isEdit" @change="handleUsername"></a-input>
                        <a-button icon="edit" @click="isEdit = true" v-if="!isEdit">编辑</a-button>
                      </a-form-item>
                      <a-form-item label="密码" v-if="isEdit">
                        <a-input type="password" v-model="password" placeholder="不输入新密码将不更新"></a-input>
                      </a-form-item>
                      <a-form-item label="确认密码" v-if="isEdit">
                        <a-input type="password" v-model="rePassword"></a-input>
                      </a-form-item>
                      <a-form-item label="操作" v-if="isEdit">
                        <a-button type="primary" @click="updateUserInfo">更新</a-button>
                      </a-form-item>
                    </a-form>
                    <div class="box mt-3" v-if="user.data.express.address">
                      <div class="box-title">
                        <h3>地址簿</h3><a href="#"></a>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <h6>邮寄地址</h6>
                          <address>
                            {{ user.data.express.postal }}<br/>
                            {{ user.data.express.address }}, {{ user.data.express.city }}<br/>
                            {{ user.data.express.province }}, {{ user.data.express.country }}<br/>
                            {{ user.data.express.firstname }} {{ user.data.express.lastname }}<br/>
                            {{ user.data.express.mobile_code }} - {{ user.data.express.mobile }}<br/>
                          </address>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" :class="{'active': currentTab === 'trade', 'show': currentTab === 'trade'}" id="orders">
                <Trades></Trades>
              </div>
              <div class="tab-pane fade" :class="{'active': currentTab === 'device', 'show': currentTab === 'device'}" id="devices">
                <Devices></Devices>
              </div>
              <div class="tab-pane fade" :class="{'active': currentTab === 'ip', 'show': currentTab === 'ip'}" id="ip">
                <IP></IP>
              </div>
              <div class="tab-pane fade" :class="{'active': currentTab === 'commission', 'show': currentTab === 'commission'}" id="commission">
                <Commission></Commission>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--  dashboard section end -->
  </div>
</template>

<script>
import { User } from '@/api/model'
import { getStat, getCommissionList } from '@/api/trade'
import { updateUserInfo } from '@/api/user'
import { baseMixin } from '@/libs/app-mixin'
import { delToken } from '@/libs/util'
import Trades from './Trades'
import Devices from './Devices'
import IP from './IP'
import Commission from './Commission'

export default {
  name: 'MyDashboard',
  mixins: [baseMixin],
  components: {
    Trades,
    Devices,
    IP,
    Commission
  },
  data () {
    return {
      user: User(),
      stats: [],
      total: [0, 0, 0],
      currentTab: 'info',
      isEdit: false,
      username: '',
      password: '',
      rePassword: '',
      coupons: []
    }
  },
  methods: {
    getStat () {
      getStat().then(res => {
        this.stats = res.result
        this.total[0] = this.showTotal([''])
        this.total[1] = this.showTotal([1])
        this.total[2] = this.showTotal([10, 20])
      })
    },
    getCommissionList () {
      getCommissionList({}).then(res => {
        this.coupons = res.result
      })
    },
    showTotal (types) {
      let total = 0
      this.stats.forEach(v => {
        if (types.includes(v.status)) {
          total += v.total
        }
      })
      return total
    },
    showMenu (type) {
      this.currentTab = type
    },
    goTrade () {
      this.showMenu('trade')
    },
    logout () {
      delToken()
      location.href = '/#/'
      setTimeout(() => {
        location.reload()
      }, 100)
    },
    updateUserInfo () {
      if (this.username.length === 0) {
        this.$message.info('请输入用户名')
        return false
      }
      if (this.password.length > 0 && this.password.length < 6) {
        this.$message.info('密码不可小于6位')
        return false
      }
      if (this.password !== this.rePassword) {
        this.$message.info('两次密码不一致')
        return false
      }
      updateUserInfo({
        username: this.username,
        password: this.password
      }).then(res => {
        if (res.code !== 200) {
          this.$message.info(res.msg)
          return false
        }
        this.$message.success('更新完成')
        location.reload()
      })
    },
    handleUsername (e) {
      let val = e.target.value
      val = val.replace("'", '').replace('"', '').replace('\\', '').replace('/', '')
      // 过滤表情
      val = val.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, '')
      this.username = val
    },
    change () {
      this.getStat()
      this.getCommissionList()
      setTimeout(() => {
        this.user = this.$parent.user
        this.username = this.user.username
      }, 1000)
    }
  },
  mounted () {
    this.change()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/My/Dashboard.vue